// src/app/baseQuery.ts
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store/store";


export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL + "/api/v1",
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Content-Type", "application/json");
    return headers;
  },
});
